
  <div class="unsave-modal">
    <div class="header">
      <h4>Unsaved Changes</h4>
      <button class="close-button" (click)="cancel(false)"><img src="assets/icons/icon-close.svg" alt=""></button>
    </div>
    
    <div class="unsave-content">
      You have unsaved changes. Are you sure you want to leave without saving?
      <div>
        {{isValidForm?'':'Please fill all the fields first to save changes'}}
      </div>
    </div>
    <div class="btn-wrapper">
      <button type="button" class="btn btn-danger" (click)="cancel(true)">Discard</button>
      <button type="button" class="btn btn-theme" (click)="confirm()" [disabled]="!isValidForm">Save</button>
    </div>
  </div>